import React, { useEffect, useState } from 'react';
import axios from 'axios';
import  colors from '../Constants/colors';  // adjust import path as needed

const TeacherSchedulePage = () => {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDay, setSelectedDay] = useState('Monday');
const teacherData = JSON.parse(localStorage.getItem("teacher"));
const teacherId = teacherData?.id;
  

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const teacherData = JSON.parse(localStorage.getItem("teacher"));
const teacherName = teacherData?.firstName + " " + teacherData?.lastName; // full name
         const sessionId = localStorage.getItem("currentSessionId");
        
        const response = await axios.get( `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherSchedule/${encodeURIComponent(teacherName)}`,
           { params: { sessionId } }
        );
        setSchedule(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching teacher schedule:', error);
        setError('Failed to fetch schedule');
        setLoading(false);
      }
    };
    fetchSchedule();
  }, []);

  if (loading) return <div>Loading schedule...</div>;
  if (error) return <div>{error}</div>;

  const getSortedPeriods = (day) => {
    let allPeriods = [];
    schedule.forEach(timetable => {
      const periods = timetable.teacherSchedule[day].map(period => ({
        ...period,
        className: timetable.className,
        sectionName: timetable.sectionName,
        scheduleName: timetable.scheduleName
      }));
      allPeriods = [...allPeriods, ...periods];
    });
    allPeriods.sort((a, b) => new Date(`1970-01-01T${a.startTime}`) - new Date(`1970-01-01T${b.startTime}`));
    return allPeriods;
  };

  const allTimeRanges = [
    ...new Set(
      schedule.flatMap(timetable =>
        ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
          .flatMap(day => timetable.teacherSchedule[day].map(period => `${period.startTime}-${period.endTime}`))
      )
    )
  ].sort((a, b) => new Date(`1970-01-01T${a.split('-')[0]}`) - new Date(`1970-01-01T${b.split('-')[0]}`));

  const renderRowForTimeRange = (timeRange, index) => {
    const [startTime, endTime] = timeRange.split('-');

    return (
      <tr key={timeRange} className="hover:bg-gray-50">
        <td className="border px-4 py-2">{index + 1}</td>
        <td className="border px-4 py-2">{`${startTime} - ${endTime}`}</td>
        {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => {
          const periods = getSortedPeriods(day).filter(period => period.startTime === startTime && period.endTime === endTime);

          if (periods.length === 0) {
            return (
              <td key={day} className="border px-4 py-2 text-gray-400 italic">
                No classes
              </td>
            );
          }

          return (
            <td key={day} className="border px-4 py-2 text-gray-700">
              {periods.map((period, index) => (
                <div
                  key={index}
                  className="mb-2 rounded-md p-2"
                  style={{ backgroundColor: colors.grayLight }}
                >
                  <p className="font-semibold" style={{ color: colors.primary }}>
                    {period.subject}
                  </p>
                  <p className="text-sm" style={{ color: colors.grayDark }}>
                    ({period.className} - {period.sectionName})
                  </p>
                </div>
              ))}
            </td>
          );
        })}
      </tr>
    );
  };

  return (
    <div className="container mx-auto md:p-4">
      {/* Back Button */}
      <button
        onClick={() => window.history.back()}
        className="mb-4 inline-flex items-center px-4 py-2 rounded-md shadow-sm font-medium transition"
        style={{
          backgroundColor: colors.primary,
          color: 'white',
          hover: { backgroundColor: '#553C9A' }, // You can add hover styles with Tailwind or inline styles differently
          cursor: 'pointer',
        }}
      >
        <i className="fas fa-arrow-left mr-2"></i> Back
      </button>

      <h1
        className="text-xl lg:text-3xl text-center font-semibold mb-2 sm:mb-6"
        style={{ color: colors.primary }}
      >
        <i className="fas fa-calendar-alt mr-2 lg:hidden sm:hidden"></i>
        Teacher Schedule - {teacherId}
      </h1>

      {schedule.length === 0 ? (
        <div>No schedule found for this teacher</div>
      ) : (
        <>
          {/* Mobile View */}
          <div className="block md:hidden">
            <div className="mb-4">
              <label
                htmlFor="dayDropdown"
                className="block text-sm font-medium mb-2"
                style={{ color: colors.grayDark }}
              >
                <i className="fas fa-sun mr-2" style={{ color: colors.secondary }}></i>
                Select Day:
              </label>
              <select
                id="dayDropdown"
                value={selectedDay}
                onChange={(e) => setSelectedDay(e.target.value)}
                className="border rounded-md p-2"
                style={{ borderColor: colors.primary }}
              >
                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => (
                  <option key={day} value={day}>{day}</option>
                ))}
              </select>
            </div>

            <div>
              <h2
                className="text-lg font-semibold mb-2"
                style={{ color: colors.primary }}
              >
                {selectedDay}
              </h2>

              {getSortedPeriods(selectedDay).map((period, index) => (
                <div
                  key={index}
                  className="p-2 border rounded-md shadow-sm mb-2"
                  style={{ backgroundColor: colors.grayLight }}
                >
                  <div className="font-semibold" style={{ color: colors.success }}>
                    <i className="fas fa-clock mr-1"></i> {period.startTime} - {period.endTime}
                  </div>
                  <div className="text-sm" style={{ color: colors.grayDark }}>
                    <i className="fas fa-chalkboard-teacher mr-1"></i>{' '}
                    <span style={{ color: 'black' }}>
                      {period.className} - {period.sectionName}
                    </span>{' '}
                    ({period.subject})
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Desktop View */}
          <div className="hidden md:block">
            <table className="min-w-full bg-white border border-gray-300 text-center">
              <thead style={{ backgroundColor: colors.grayLight }}>
                <tr>
                  <th className="border px-4 py-2">Sr No.</th>
                  <th className="border px-4 py-2">Timing</th>
                  <th className="border px-4 py-2">Monday</th>
                  <th className="border px-4 py-2">Tuesday</th>
                  <th className="border px-4 py-2">Wednesday</th>
                  <th className="border px-4 py-2">Thursday</th>
                  <th className="border px-4 py-2">Friday</th>
                  <th className="border px-4 py-2">Saturday</th>
                </tr>
              </thead>
              <tbody>{allTimeRanges.map(renderRowForTimeRange)}</tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default TeacherSchedulePage;
